//IF occupancy year is less than today's year AND today's month is less than October, then tax year = today's year
//ELSE tax year = next year
//January 2, (x - 1) through January 1, (x) inclusive is the valid set of occupancy dates for filing year x
export function determineFilingYear(inputOccupancyDate) {
    let occupancyDate = new Date(`${inputOccupancyDate} CST`)
    let today = new Date()
    let taxYear = today.getFullYear()
    
    if((occupancyDate.getFullYear() >= today.getFullYear() && !(occupancyDate.getMonth() === 0 && occupancyDate.getDate() === 1 && occupancyDate.getFullYear() === today.getFullYear())) || today.getMonth() >= 9) {
        taxYear++
    }

    return taxYear
}